import script from "./certificateReceiveInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./certificateReceiveInfo.vue?vue&type=script&setup=true&lang=js"

import "./certificateReceiveInfo.vue?vue&type=style&index=0&id=49ae3e58&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ae3e58"]])

export default __exports__